import { badgeColors } from 'constants/colors'

export enum FrequencyType {
  DAY = 0,
  WEEK = 1,
  MONTH = 2,
}

export enum RecipientType {
  USER = 0,
  GROUP = 1,
  TAG = 2,
}

export const frequencyLabel = (value: number | null) => {
  switch (value) {
    case FrequencyType.DAY:
      return 't_day'
    case FrequencyType.WEEK:
      return 't_week'
    case FrequencyType.MONTH:
      return 't_month'
    default:
      return 't_frequency'
  }
}

export const getFrequencyColor = (value: number) => {
  switch (value) {
    case FrequencyType.DAY:
      return badgeColors.teal
    case FrequencyType.WEEK:
      return badgeColors.cyan
    case FrequencyType.MONTH:
      return badgeColors.purple
    default:
      return badgeColors.default
  }
}

export const REMOVAL_OFFSET = 8
